// extracted by mini-css-extract-plugin
export default {"form":"Form_form__gpIe9","textArea":"Form_textArea__M4Zya","submit":"Form_submit__v27C9"};